module.exports = __webpack_public_path__ + "static/media/440436323_947210253749564_5585816951053138751_n.51d6d402.jpg";